/* eslint-disable quote-props */
import { put, call, takeEvery } from 'redux-saga/effects';
import { fetchApiAuth, formatParams, makeParamString } from '../utils/api';

import {
    getSessionsSuccess,
    getSessionsFailure,

    getSessionRecordsSuccess,
    getSessionRecordsFailure,

    createSessionSuccess,
    createSessionFailure,

    updateSessionSuccess,
    updateSessionFailure,

    deleteSessionSuccess,
    deleteSessionFailure,
} from './sessionActions';

const {
    GET_SESSIONS_REQUEST,
    GET_SESSION_RECORDS_REQUEST,
    CREATE_SESSION_REQUEST,
    UPDATE_SESSION_REQUEST,
    DELETE_SESSION_REQUEST,
} = require('./sessionActions').constants;

function* getSessions({ payload }) {
    try {
        const params = payload ? makeParamString(formatParams(payload)) : '';
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: `/session${params}`,
        });
        yield put(getSessionsSuccess(response));
    } catch (e) {
        yield put(getSessionsFailure(e.response ? e.response.data.message : e));
    }
}

function* getSessionRecords({ payload }) {
    try {
        const params = payload ? makeParamString(formatParams(payload)) : '';
        const response = yield call(fetchApiAuth, {
            method: 'GET',
            url: `/session-record${params}`,
        });
        yield put(getSessionRecordsSuccess(response));
    } catch (e) {
        yield put(getSessionRecordsFailure(e.response ? e.response.data.message : e));
    }
}

function* createSession({ payload }) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: '/session/update',
            body: payload,
        });
        yield put(createSessionSuccess(response));
    } catch (e) {
        yield put(createSessionFailure(e.response ? e.response.data.message : e));
    }
}

function* updateSession({ payload }) {
    try {
        const { id, ...data } = payload;
        const response = yield call(fetchApiAuth, {
            method: 'POST',
            url: `/session/${id}/update`,
            body: data,
        });
        yield put(updateSessionSuccess(response));
    } catch (e) {
        yield put(updateSessionFailure(e.response ? e.response.data.message : e));
    }
}

function* deleteSession({ payload }) {
    try {
        const response = yield call(fetchApiAuth, {
            method: 'DELETE',
            url: `/session/${payload.id}/delete`,
        });
        yield put(deleteSessionSuccess(response));
    } catch (e) {
        yield put(deleteSessionFailure(e.response ? e.response.data.message : e));
    }
}

export default function* sessionSaga() {
    yield* [
        takeEvery(GET_SESSIONS_REQUEST, getSessions),
        takeEvery(GET_SESSION_RECORDS_REQUEST, getSessionRecords),
        takeEvery(CREATE_SESSION_REQUEST, createSession),
        takeEvery(UPDATE_SESSION_REQUEST, updateSession),
        takeEvery(DELETE_SESSION_REQUEST, deleteSession),
    ];
}
